import React, { useState, useEffect } from 'react'
import './Home.css'
import Footer from '../UIElements/Footer'
import HomeHomeNavigation from './HomeHomeNavigation'
import LoadingSpinner from '../UIElements/LoadingSpinner'
import ErrorModal from '../UIElements/ErrorModal'
import brookline from '../images/brookline.png'
import bridgeville from '../images/bridgeville.jpeg'
import falcons from '../images/falcons.png'
import venom from '../images/venom.png'
import pennHills from '../images/pennHills.jpg'
import riverview from '../images/riverview.jpg'
import southHills from '../images/southHills.png'
import cranberry from '../images/cranberryNew2.jpg'
import murrysville from '../images/MurrysvilleSportzone.png'
import mckeesport from '../images/McKeesport.png'
import pabhaHeroLogo from '../images/pabhaLogoOriginal.png'
import teampitt from '../images/teamPittNew.png'
import tournamentSchedule from '../images/2027_schedule.png'
//import emailjs from 'emailjs-com'
//import YouTube from 'react-youtube'
//var getYouTubeID = require('get-youtube-id')

const Home = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [ids, setIds] = useState([])
	const [videoTitles, setVideoTitles] = useState([])
	const [videoCaptions, setVideoCaptions] = useState([])
	const [loadedVideos, setLoadedVideos] = useState([])
	const [loadedNews, setLoadedNews] = useState([])

	//
	//
	//
	//
	//
	//
	//
	//Get all News
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/news',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				console.log(responseData.allNews)

				setLoadedNews(responseData.allNews)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest2()
	}, [])
	//
	//
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	/* function sendEmail(e) {
		e.preventDefault()

		const fromEmail = document.getElementById('fromEmail').value
		const fromName = document.getElementById('fromName').value

		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

		const validEmail = emailRegex.test(fromEmail)

		console.log('isValidEmail: ' + emailRegex.test(fromEmail))

		if (!fromEmail) {
			alert('Please enter an email address so we can respond back to you!')
		}
		if (!validEmail) {
			alert('Please enter a valid email address!')
		}
		if (!fromName) {
			alert('Please enter your name')
		}

		if (fromEmail && fromName && validEmail) {
			emailjs
				.sendForm(
					'service_qeuvtpo',
					'template_62za9ey',
					document.getElementById('emailForm'),
					'GFXJpgnQXBXpF8Y3w',
				)
				.then((res) => {
					console.log('res: ' + JSON.stringify(res))
					alert('Your email is on its way!')
					document.getElementById('emailForm').reset()
				})
				.catch((err) => console.log(err))
		}
	} */
	//
	//
	//
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && <LoadingSpinner asOverlay />}

				{!isLoading && (
					<div>
						<div>
							<header className='homeHeader'>
								<HomeHomeNavigation />

								<div className='heroContent'>
									<div className='heroSide heroSideLeft'>
										<div className='heroLine'></div>
										<p className='heroPhrase heroPhraseLight'>
											GROWING
											<br />
											THE GAME
										</p>
										<div className='heroLine'></div>
									</div>

									<div className='heroCenter'>
										<img
											src={pabhaHeroLogo}
											alt='PABHA logo'
											className='heroLogoMain'
										/>
									</div>

									<div className='heroSide heroSideRight'>
										<div className='heroLine'></div>
										<p className='heroPhrase heroPhraseRed'>
											IN THE
											<br />
											KEYSTONE STATE
										</p>
										<div className='heroLine'></div>
									</div>
								</div>
							</header>
						</div>
						<div className='p-5' style={{ backgroundColor: 'white' }}>
							<div className='row'>
								<a
									href='https://docs.google.com/forms/d/1ywtEi9iAm3rLKxpIvYp62wRNfye1-44bI3TmycxdmYU/viewform?pli=1&pli=1&edit_requested=true'
									className='centeredButtonSmallMargin commitmentFormButton'
									target='_blank'
									style={{
										display: 'block',
										width: 'auto',
										fontWeight: '700',
										backgroundColor: 'red',
										color: 'white',
										borderRadius: '4px',
										textDecoration: 'none',
										boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.4)',
									}}
								>
									2026 PABHA Player Commitment Form
								</a>
							</div>
							{/* <div className='row'>
								<a
									href='https://docs.google.com/forms/d/1QTgBNbnYCLww6Turja-qSx6DintlNNdcbp9eSybj1UE/viewform?edit_requested=true&pli=1'
									className='centeredButtonSmallMargin commitmentFormButton'
									target='_blank'
									style={{
										display: 'block',
										width: 'auto',
										fontWeight: '700',
										backgroundColor: 'red',
										color: 'white',
										borderRadius: '4px',
										textDecoration: 'none',
										boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.4)',
									}}
								>
									PABHA Request for Reinstatement 2026
								</a>
							</div> */}
							{/* //
							//
							//
							//
							//
							// */}
							{/* <div className='row'>
								<a
									href='https://docs.google.com/forms/d/e/1FAIpQLSdX_pRplBXhjEsibScxOjhfCTL2M1-wLZNm9Z8ZrDYj9F-8KA/viewform'
									className='centeredButtonSmallMargin commitmentFormButton'
									target='_blank'
									style={{
										display: 'block',
										width: 'auto',
										fontWeight: '700',
										backgroundColor: 'red',
										color: 'white',
										borderRadius: '4px',
										textDecoration: 'none',
										boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.4)',
									}}
								>
									PABHA 2025 Player Commitment Form
								</a>
							</div> */}
							<div className='row'>
								<div className='col text-center mb-3'>
									<h1
										className='displayProperty font-weight-bold'
										style={{ color: '#a20200' }}
									>
										About Us
									</h1>
									<blockquote className='blockquote'>
										<p className='lead text-secondary missionQuote'>
											The mission of the PA Ball Hockey Association (PABHA) is
											to grow and foster the game of Ball Hockey throughout the
											state of Pennsylvania. The propmotion of fair play,
											integrity, and positive reinforcement will better allow
											young athletes and their orginizations to positively
											impact not only their own interests, but rather that of
											the entire sport. We shall always be guided by and strive
											to live to the motto:{' '}
										</p>
										<strong>
											<italic>
												"We will always do what's best for our athletes and the
												growth of the game, and not that of our private or
												professional interests."
											</italic>
										</strong>
									</blockquote>
									<div className='underline-blue mb-4'></div>
								</div>

								<h2 style={{ color: 'red' }}>Executive Board</h2>
								<div className='col text-center mt-1 mb-3'>
									{/* <h4 className='lead text-secondary'>President - Jon Strom</h4> */}
									<h4 className='lead text-secondary'>
										President - Jennifer Free
									</h4>
									<h4 className='lead text-secondary'>
										Vice President - Justin Studeny
									</h4>
									<h4 className='lead text-secondary'>
										Treasurer - Paul Buckwalter
									</h4>
									<h4 className='lead text-secondary'>
										Secretary - Greg Renko
									</h4>
									<h4 className='lead text-secondary'>
										Head of Officials - Mike McClure
									</h4>
									<div className='underline-blue mb-4'></div>
								</div>
								<h2 style={{ color: 'red' }}>
									PABHA Organization Representatives
								</h2>
								<div className='col text-center mt-1 mb-3'>
									<h4 className='orgRep'>
										Bridgeville -
										<a href='mailto:matthew.duermeyer@gmail.com'>
											{' '}
											Matt Duermeyer
										</a>
									</h4>
									{/* <h4 className='orgRep'>
										South Pittsburgh -
										<a href='mailto:Boardrepspbh@gmail.comm'> Rich Mader</a>
									</h4> */}
									<h4 className='orgRep'>
										Cranberry -
										<a href='mailto:Jsbst22@hotmail.com'> Josh Baron</a>
									</h4>
									<h4 className='orgRep'>
										McKeesport -
										<a href='mailto:mckdekhockey@gmail.com'> Justin Evans</a>
									</h4>
									{/* <h4 className='orgRep'>
										Penn Hills -
										<a href='mailto:roccopro7@gmail.com'> Rocco Procida</a>
									</h4> */}
									<h4 className='orgRep'>
										Venom -
										<a href='mailto:justin.studeny@gmail.com'>
											{' '}
											Justin Studeny
										</a>
									</h4>
									{/* <h4 className='orgRep '>
										Bill's Dek Hockey -
										<a href='mailto:wmckeen@usaballhockey.com'>
											{' '}
											Willie McKeen
										</a>
									</h4> */}
									{/* <h4 className='orgRep'>
										Riverview -
										<a href='mailto:Mcdermottjas@gmail.com'> Jason McDermott</a>
									</h4> */}
									<h4 className='orgRep'>
										Murrysville -
										<a href='mailto:chaugh@murrysvillesportzone.com'>
											{' '}
											Colin Haugh
										</a>
									</h4>
									<div className='underline-blue mb-4'></div>
								</div>
								{/* <div className='underline-red mb-4'></div> */}
							</div>
						</div>
						<div className='p-5' style={{ backgroundColor: '#e0e0e0' }}>
							<div className='row'>
								<div className='col text-center mb-3'>
									<h1
										className='displayProperty font-weight-bold'
										style={{ color: '#a20200' }}
									>
										2027 Tournament Schedule
									</h1>
									{/* <h5 style={{ color: '#a20200' }}>coming soon.....</h5> */}
									<div className='row'>
										<img
											src={tournamentSchedule}
											className='img-thumbnail tournamentSchedule'
										/>
									</div>
									<p className='lead text-secondary'></p>
								</div>
							</div>
						</div>

						<div className='p-5' style={{ backgroundColor: 'white' }}>
							<div className='row'>
								<div className='col text-center mb-3'>
									<h1
										className='displayProperty font-weight-bold'
										style={{ color: '#a20200' }}
									>
										Members of PABHA
									</h1>
									<p className='lead text-secondary'>
										Find a PABHA organization near you!
									</p>
								</div>
								{/************************************************************* //
								//
								//    Row One
								//
								// ***********************************************************/}
								<div className='row iconRow'>
									<div
										className='col-lg-4 col-md-4 col-sm-6'
										style={{ marginBottom: '3rem' }}
									>
										<a
											href='https://www.vipersinline.com/index.html'
											target='_blank'
										>
											<img
												src={bridgeville}
												className='img-thumbnail brookline'
											/>
										</a>
										<h3
											className='my-3'
											style={{ textAlign: 'center', color: '#a20200' }}
										>
											Bridgeville Vipers
										</h3>
									</div>
									<div
										className='col-lg-4 col-md-4 col-sm-6'
										style={{ marginBottom: '3rem' }}
									>
										<a href='https://mckdekhockey.com/' target='_blank'>
											<img
												src={mckeesport}
												className='img-thumbnail mckeesport'
											/>
										</a>
										<h3
											className='my-3'
											style={{ textAlign: 'center', color: '#a20200' }}
										>
											McKeesport Dek Hockey
										</h3>
									</div>

									<div
										className='col-lg-4 col-md-4 col-sm-6'
										style={{ marginBottom: '3rem' }}
									>
										<a href='https://venomballhockey.com/' target='_blank'>
											<img src={venom} className='img-thumbnail venom' />
										</a>
										<h3
											className='my-3'
											style={{ textAlign: 'center', color: '#a20200' }}
										>
											Venom Ball Hockey
										</h3>
									</div>
								</div>
								{/************************************************************* //
								//
								//    Row Two
								//
								// ***********************************************************/}
								<div className='row iconRow'>
									<div
										className='col-lg-4 col-md-4 col-sm-6'
										style={{ marginBottom: '3rem' }}
									>
										<a href='https://murrysvillesportzone.com/' target='_blank'>
											<img
												src={murrysville}
												className='img-thumbnail murrysville'
											/>
										</a>
										<h3
											className='my-3'
											style={{ textAlign: 'center', color: '#a20200' }}
										>
											Murrysville Dek Hockey
										</h3>
									</div>
									{/* <div
										className='col-lg-4 col-md-4 col-sm-6'
										style={{ marginBottom: '3rem' }}
									>
										<a
											href='https://www.riverviewdekhockey.com/'
											target='_blank'
										>
											<img
												src={riverview}
												className='img-thumbnail riverview'
											/>
										</a>
										<h3
											className='my-3'
											style={{ textAlign: 'center', color: '#a20200' }}
										>
											Riverview Raptors
										</h3>
									</div> */}
									<div
										className='col-lg-4 col-md-4 col-sm-6'
										style={{ marginBottom: '3rem' }}
									>
										{/* <a href='https://www.eaglesdekhockey.com/' target='_blank'> */}
										<a href='https://eaglesdekhockey.web.app/' target='_blank'>
											<img
												src={cranberry}
												className='img-thumbnail cranberry'
											/>
										</a>
										<h3
											className='my-3'
											style={{ textAlign: 'center', color: '#a20200' }}
										>
											Cranberry Screaming Eagles
										</h3>
									</div>
								</div>
								{/************************************************************* //
								//
								//    Row Three
								//
								// ***********************************************************/}
							</div>
						</div>
					</div>
				)}
				<div
					style={{
						backgroundColor: '#e0e0e0',
						padding: '2rem 1.5rem',
						textAlign: 'center',
					}}
				>
					<h1
						style={{
							color: '#a20200',
							fontWeight: '700',
							fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
							marginBottom: '0.75rem',
						}}
					>
						Questions?
					</h1>

					<h2
						style={{
							color: '#777',
							fontWeight: '600',
							fontSize: 'clamp(1.4rem, 2.5vw, 2rem)',
							marginBottom: '1.75rem',
						}}
					>
						We're here to help.
					</h2>

					<div
						style={{
							width: '110px',
							height: '3px',
							backgroundColor: '#a20200',
							margin: '0 auto 2rem',
						}}
					></div>

					<div
						style={{
							fontSize: 'clamp(1.1rem, 2vw, 1.6rem)',
							color: '#222',
							lineHeight: '1.6',
						}}
					>
						<span>Contact us: </span>

						<a
							href='mailto:paballhockeyassociation@gmail.com'
							style={{
								color: '#a20200',
								fontWeight: '700',
								textDecoration: 'none',
								wordBreak: 'break-word',
							}}
						>
							paballhockeyassociation@gmail.com
						</a>
					</div>

					<a
						href='mailto:paballhockeyassociation@gmail.com'
						aria-label='Email PABHA'
						style={{
							display: 'inline-flex',
							alignItems: 'center',
							justifyContent: 'center',
							marginTop: '1.75rem',
							color: '#a20200',
							textDecoration: 'none',
						}}
					>
						<svg
							width='58'
							height='58'
							viewBox='0 0 24 24'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<rect
								x='3'
								y='5'
								width='18'
								height='14'
								rx='1'
								stroke='currentColor'
								strokeWidth='1.8'
							/>
							<path
								d='M4 6L12 13L20 6'
								stroke='currentColor'
								strokeWidth='1.8'
								strokeLinecap='round'
								strokeLinejoin='round'
							/>
						</svg>
					</a>
				</div>
				{/* <div className='p-5' style={{ backgroundColor: '#e0e0e0' }}>
					<div>
						<div className='row'>
							<div className='col text-center mb-3'>
								<h1
									className='display-2 font-weight-bold'
									style={{ color: '#a20200' }}
								>
									Contact Us
								</h1>
							</div>
						</div>
						<div className='row justify-content-center'>
							<div className='col-lg-6 col-md-8 col-sm-10'>
								<div className='text-center text-secondary'>
									<h2>Got a Question?</h2>
									<p>Stay Connected</p>
								</div>
								<form
									id='emailForm'
									className='text-muted'
									method='post'
									enctype='text/plain'
								>
									<div className='form-group'>
										<label for='name'>Name</label>
										<input
											type='text'
											className='form-control'
											id='fromName'
											name='fromName'
											required
										/>
									</div>
									<div className='form-group'>
										<label for='email'>Email</label>
										<input
											type='email'
											className='form-control'
											id='fromEmail'
											name='fromEmail'
											required
										/>
									</div>
									<div className='form-group'>
										<label for='message'>Message</label>
										<textarea
											name='message'
											className='form-control'
											id='message'
											rows='3'
											required
										></textarea>
									</div>
									<button
										className='btn btn-block'
										type='button submitEmailButton'
										onClick={sendEmail}
										style={{
											width: '100%',
											color: '#a20200',
											borderColor: '#a20200',
										}}
									>
										Submit Question
									</button>
								</form>
							</div>
						</div>
					</div>
				</div> */}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default Home
